// Flattens the account tree into rows with a depth, so rendering needs no recursive component.
export const flattenAccounts = (nodes, collapsed, depth = 0, out = []) => {
  nodes.forEach((node) => {
    const kids = node.children || [];
    out.push({ ...node, depth, hasKids: kids.length > 0 });
    if (kids.length && !collapsed.includes(node.code)) flattenAccounts(kids, collapsed, depth + 1, out);
  });
  return out;
};
